import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "article-jump-nav",
  class ArticleJumpNav extends WYATTElement {
    connectedCallback() {
      this.content = document.querySelector("[data-jump-nav-content]");
      this.removeEmptyHeaders();
      this.headers = this.content.querySelectorAll("h2");

      if (this.headers.length) {
        this.updateHeaderIDs();
        this.insertAdjacentHTML("beforeend", this.navHTML());
      } else {
        this.remove();
      }
    }

    removeEmptyHeaders() {
      this.content.querySelectorAll("h2").forEach((header) => {
        if (header.textContent === "") header.remove();
      });
    }

    updateHeaderIDs() {
      this.headers.forEach((header) => {
        header.id = header.textContent
          .toLowerCase()
          .replace(/ /g, "_")
          .match(/[a-zA-Z0-9]|_/g)
          .join("");
      });
    }

    navHTML() {
      return `
        <nav>
          <ol class="${this.className}__items list-reset">
            ${this.navItemsHTML()}
          </ol>
        </nav>
      `;
    }

    navItemsHTML() {
      return Array.from(this.headers)
        .map(
          (header) => `
          <li class="${this.className}__item">
            <a class="${this.className}__link" href="#${header.id}">${header.textContent}</a>
          </li>
        `,
        )
        .join("");
    }
  },
);
